import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
// import DropDown from '../DropDown';
import ProgressBar from '../ProgressBar';
import PickupCount from '../PickupCount';
import FormInput from '../FormInput';
import { TextField } from '@material-ui/core';
import UserList from '../UserList';
import Avator from '../Picture';

import LoaderGif from '../../icons/LoaderGif.gif';

import { Accordion, Card, Col, Row, Modal } from 'react-bootstrap';

import { uploadImage } from './../../helpers/uploadImageToAWS';

import LoadingComponent from './../LoadingComponent';

function AdminContentCard({
    cardType,
    heading,
    users,
    inputTitle,
    onAddUser,
    onRemoveUser,
    onCancelInvite,
    loading,
    countText,
    total,
    count,
    showPartnerButton,
    showAddButton,
    showDeleteButton,
    partners,
    onAddChildUser,
    onRemoveChildUser,
    onPartnerCreate,
    userId,
    emailError,
    emailChildId,
    deleteError,
    deleteChildId,
    createPartnerError,
    showLoading,
    childRequested,
    childRequestedId,
    isPartnerCreateRequested,
    childTotal,
    childPartnerInProgress,
    childPartnerInProgressId,

    onClearErrors,
}) {
    const defaultPartnerImage =
        'https://litterati-avatars-prod.s3-us-west-2.amazonaws.com/users/user-default/profile-picture-aqua.png';
    const [email, setEmail] = useState(null);
    const [emails, setEmails] = useState({});

    const [open, setOpen] = useState(false);
    const [partnerOrganization, setPartnerOrganization] = useState(null);
    const [partnerEmail, setPartnerEmail] = useState(null);
    const [partnerBio, setPartnerBio] = useState(null);
    const [partnerImage, setPartnerImage] = useState(defaultPartnerImage);
    const [partnerBanner, setPartnerBanner] = useState(null);
    const [uploadingImage, setUploadingImage] = useState(false);
    const [uploadingBanner, setUploadingBanner] = useState(false);
    const [uploadingBannerSuccess, setUploadingBannerSuccess] = useState(false);
    const [emailFormatError, setEmailFormatError] = useState(null);
    const [childEmailFormatErrorId, setChildEmailFormatErrorId] = useState(
        null,
    );
    const [partnerEmailError, setPartnerEmailError] = useState(null);
    // const [closeModal,setCloseModal] = useState(false);

    useEffect(() => {
        handleClose();
    }, [partners]);
    if (
        emailError ||
        deleteError ||
        emailFormatError ||
        createPartnerError ||
        partnerEmailError
    ) {
        setTimeout(() => {
            onClearErrors();
            setEmailFormatError(null);
            setPartnerEmailError(null);
        }, 8000);
    }

    // eslint-disable-next-line
    const emailRegex = new RegExp(/\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/);
    const quotaError = 'Maximum Capacity Reached! Please Contact Support!';
    var quotaType = cardType === 'LIST' ? 'USER' : 'PARTNER';

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function clickUploadBanner() {
        document.getElementById('upload_banner').click();
    }

    function clickUploadImage() {
        document.getElementById('upload_image_input').click();
    }

    function clearPartner() {
        setPartnerEmail(null);
        setPartnerBio(null);
        setPartnerOrganization(null);
        setPartnerImage(defaultPartnerImage);
        setPartnerBanner(null);
    }

    async function uploadToS3(type, e) {
        type == 'PartnerProfile'
            ? setUploadingImage(true)
            : setUploadingBanner(true);
        let response = await uploadImage(e);
        setUploadingImage(false);
        setUploadingBanner(false);
        if (type == 'PartnerProfile') setPartnerImage(response);
        if (type == 'PartnerBanner') {
            setUploadingBannerSuccess(true);
            setPartnerBanner(response);
        }
    }

    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={true} />
        </div>
    );

    function addToList(id = null, adminCount = {}) {
        var disableAdd =
            adminCount && adminCount.currentAdminsCount >= childTotal
                ? true
                : count >= total && cardType == 'LIST'
                ? true
                : false;
        return (
            <form
                className="row align-middle"
                onSubmit={(e) => {
                    e.preventDefault();
                    if (id) {
                        if (!emails[id]) {
                            setEmailFormatError(`Email cannot be empty!`);
                            setChildEmailFormatErrorId(id);
                        } else if (!emailRegex.test(emails[id])) {
                            setEmailFormatError(
                                `Email does not match the format 'abc@abc.com'!`,
                            );
                            setChildEmailFormatErrorId(id);
                        } else {
                            if (count < total && quotaType == 'USER') {
                                onAddUser(emails[id]);
                            } else if (quotaType === 'PARTNER') {
                                onAddChildUser(id, emails[id]);
                            }
                            setEmails({ ...emails, [id]: null });
                        }
                    } else {
                        if (!email) {
                            setEmailFormatError(`Email cannot be empty!`);
                            setChildEmailFormatErrorId(id);
                        } else if (!emailRegex.test(email)) {
                            setEmailFormatError(
                                `Email does not match the format 'abc@abc.com'!`,
                            );
                            setChildEmailFormatErrorId(id);
                        } else {
                            if (count < total && quotaType == 'USER') {
                                onAddUser(email);
                            } else if (quotaType === 'PARTNER') {
                                onAddChildUser(id, email);
                            }
                            setEmail('');
                        }
                    }
                }}
            >
                <div className="col-lg-10 col-md-8 col-xs-12">
                    <FormInput
                        title={
                            childTotal
                                ? inputTitle +
                                  ` (${adminCount.currentAdminsCount}/${childTotal})`
                                : inputTitle
                        }
                        bootstrapIcon="icon-latest-add"
                    >
                        <TextField
                            value={id ? emails[id] || '' : email || ''}
                            type={'email'}
                            placeholder={'Email Address'}
                            onChange={(event) => {
                                if (id) {
                                    setEmails({
                                        ...emails,
                                        [id]: event.target.value,
                                    });
                                } else {
                                    setEmail(event.target.value);
                                }
                            }}
                        />
                    </FormInput>
                </div>
                <div className="col-lg-2 col-md-4 align-self-end">
                    <button
                        className="btn btn-custom btn-block add-button"
                        type="submit"
                        disabled={disableAdd}
                    >
                        {showLoading
                            ? loader
                            : childRequested && childRequestedId == id
                            ? loader
                            : 'Add'}
                    </button>
                </div>
            </form>
        );
    }

    function getContent(cardType) {
        switch (cardType) {
            case 'LIST':
                return (
                    <div className="admin-content-box">
                        <div className="card-header">
                            <div className="row">
                                <div className="col">
                                    <h2 className="title">{heading}</h2>
                                    <PickupCount
                                        countText={countText}
                                        count={count}
                                        total={total}
                                        loading={loading}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <ProgressBar
                                        progress={(count / total) * 100}
                                    />
                                </div>
                            </div>
                        </div>
                        {deleteError ? (
                            <div className="row ml-1">{deleteError}</div>
                        ) : null}
                        {typeof total == 'number' && cardType == 'LIST' ? (
                            <UserList
                                users={users}
                                userId={userId}
                                onRemoveUser={(id) => onRemoveUser(id)}
                                onCancelInvite={(email) =>
                                    onCancelInvite(email)
                                }
                                showDeleteButton={showDeleteButton}
                                componentType={heading}
                            />
                        ) : (
                            <div className="row justify-content-center">
                                <img src={LoaderGif} />
                            </div>
                        )}
                        <div className="add-user">
                            {showAddButton ? addToList() : null}
                        </div>

                        {count >= total && quotaType === 'USER'
                            ? quotaError
                            : emailFormatError && !childEmailFormatErrorId
                            ? emailFormatError
                            : emailError}
                    </div>
                );
            case 'ACCORDION':
                return (
                    <div className="admin-content-box">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-lg-9 col-md-8 col-sm-7">
                                    <h2 className="partner-title">{heading}</h2>
                                </div>
                                {showPartnerButton ? (
                                    <div className="col">
                                        <button
                                            className="btn btn-custom btn-partner"
                                            onClick={() => {
                                                clearPartner();
                                                handleOpen();
                                            }}
                                            disabled={
                                                count === total ? true : false
                                            }
                                        >
                                            + Create Partner
                                        </button>
                                        <Modal
                                            show={open}
                                            onHide={handleClose}
                                            className={'create-partner-modal'}
                                            aria-labelledby="simple-modal-title"
                                            aria-describedby="simple-modal-description"
                                            centered={true}
                                            animation={true}
                                        >
                                            {/* Modal code starts here */}
                                            <div className="modal-body">
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row justify-content-end">
                                                            <div className="col-1">
                                                                <button
                                                                    className="close-partner-modal"
                                                                    onClick={() =>
                                                                        handleClose()
                                                                    }
                                                                >
                                                                    {' '}
                                                                    X{' '}
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col create-partner-heading">
                                                                Create Partner
                                                            </div>
                                                        </div>

                                                        <div className="row justify-content-center mt-4">
                                                            <div
                                                                className="col-3"
                                                                style={{
                                                                    backgroundImage: `url(${partnerImage})`,
                                                                    backgroundSize:
                                                                        'cover',
                                                                    backgroundRepeat:
                                                                        'no-repeat',
                                                                    backgroundPosition:
                                                                        'center',
                                                                    height:
                                                                        '120px',
                                                                    borderRadius:
                                                                        '100%',
                                                                }}
                                                            >
                                                                <button
                                                                    className="upload-image"
                                                                    onClick={() =>
                                                                        clickUploadImage()
                                                                    }
                                                                >
                                                                    {uploadingImage ? (
                                                                        <img
                                                                            src={
                                                                                LoaderGif
                                                                            }
                                                                            alt=""
                                                                            className="Loader"
                                                                        ></img>
                                                                    ) : (
                                                                        <span className="icon-latest-camera"></span>
                                                                    )}
                                                                </button>
                                                                <input
                                                                    type="file"
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        uploadToS3(
                                                                            'PartnerProfile',
                                                                            e,
                                                                        )
                                                                    }
                                                                    id={
                                                                        'upload_image_input'
                                                                    }
                                                                    hidden={
                                                                        true
                                                                    }
                                                                ></input>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-3 justify-content-center">
                                                            <div className="col-3 text-center package-text">
                                                                {heading}
                                                            </div>
                                                        </div>
                                                        <form
                                                            onSubmit={(e) => {
                                                                e.preventDefault();
                                                                if (
                                                                    emailRegex.test(
                                                                        partnerEmail,
                                                                    )
                                                                ) {
                                                                    onPartnerCreate(
                                                                        {
                                                                            name: partnerOrganization,
                                                                            email: partnerEmail,
                                                                            description: partnerBio,
                                                                            profilePicture: partnerImage,
                                                                            banner: partnerBanner
                                                                                ? partnerBanner
                                                                                : null,
                                                                        },
                                                                    );
                                                                } else {
                                                                    setPartnerEmailError(
                                                                        `Email does not match the format 'abc@abc.com'!`,
                                                                    );
                                                                }
                                                            }}
                                                        >
                                                            <div className="row mt-4">
                                                                <div className="col-12">
                                                                    <FormInput
                                                                        title={
                                                                            'Organization Name'
                                                                        }
                                                                        bootstrapIcon="icon-latest-organization"
                                                                    >
                                                                        <TextField
                                                                            value={
                                                                                partnerOrganization
                                                                            }
                                                                            type={
                                                                                'text'
                                                                            }
                                                                            required={
                                                                                true
                                                                            }
                                                                            placeholder={
                                                                                'Add Organization Name'
                                                                            }
                                                                            onChange={(
                                                                                event,
                                                                            ) =>
                                                                                setPartnerOrganization(
                                                                                    event
                                                                                        .target
                                                                                        .value,
                                                                                )
                                                                            }
                                                                        />
                                                                    </FormInput>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <FormInput
                                                                        title={
                                                                            'Email'
                                                                        }
                                                                        bootstrapIcon="icon-latest-envelop"
                                                                    >
                                                                        <TextField
                                                                            value={
                                                                                partnerEmail
                                                                            }
                                                                            required={
                                                                                true
                                                                            }
                                                                            type={
                                                                                'email'
                                                                            }
                                                                            placeholder={
                                                                                'Email for Admin of Partner Account'
                                                                            }
                                                                            onChange={(
                                                                                event,
                                                                            ) =>
                                                                                setPartnerEmail(
                                                                                    event
                                                                                        .target
                                                                                        .value,
                                                                                )
                                                                            }
                                                                        />
                                                                    </FormInput>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-12 bio-textarea">
                                                                    <FormInput
                                                                        title={
                                                                            'Bio'
                                                                        }
                                                                        bootstrapIcon="icon-latest-pencil"
                                                                    >
                                                                        <TextField
                                                                            value={
                                                                                partnerBio
                                                                            }
                                                                            type={
                                                                                'text'
                                                                            }
                                                                            placeholder={
                                                                                'Write a bio about the organization'
                                                                            }
                                                                            onChange={(
                                                                                event,
                                                                            ) =>
                                                                                setPartnerBio(
                                                                                    event
                                                                                        .target
                                                                                        .value,
                                                                                )
                                                                            }
                                                                            multiline
                                                                            rows={
                                                                                8
                                                                            }
                                                                        />
                                                                    </FormInput>
                                                                </div>
                                                            </div>
                                                            <button
                                                                id={
                                                                    'form_submit_botton'
                                                                }
                                                                hidden={true}
                                                            ></button>
                                                        </form>

                                                        <div className="row mt-4">
                                                            <div className="col create-partner-heading">
                                                                <button
                                                                    className={
                                                                        'btn btn-block btn-upload upload-banner'
                                                                    }
                                                                    onClick={() =>
                                                                        clickUploadBanner()
                                                                    }
                                                                >
                                                                    <span className="icon-latest-gallery upload-banner-icon"></span>
                                                                    {uploadingBanner ? (
                                                                        <img
                                                                            src={
                                                                                LoaderGif
                                                                            }
                                                                            width={
                                                                                '25px'
                                                                            }
                                                                            height={
                                                                                '25px'
                                                                            }
                                                                        />
                                                                    ) : uploadingBannerSuccess ? (
                                                                        'Upload Successful'
                                                                    ) : (
                                                                        'Upload Banner'
                                                                    )}
                                                                </button>
                                                                <input
                                                                    type="file"
                                                                    id={
                                                                        'upload_banner'
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        uploadToS3(
                                                                            'PartnerBanner',
                                                                            e,
                                                                        )
                                                                    }
                                                                    hidden={
                                                                        true
                                                                    }
                                                                ></input>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-5 mb-4">
                                                            {/* partner creation error */}
                                                            {/* {createPartnerError ? (
                                                                <div className="col-12 text-center">
                                                                    {createPartnerError}
                                                                </div>
                                                            ) : null} */}
                                                            {partnerEmailError ? (
                                                                <div className="col-12 text-center">
                                                                    {
                                                                        partnerEmailError
                                                                    }
                                                                </div>
                                                            ) : createPartnerError ? (
                                                                <div className="col-12 text-center">
                                                                    {
                                                                        createPartnerError
                                                                    }
                                                                </div>
                                                            ) : null}
                                                            <div className="col create-partner-heading">
                                                                <button
                                                                    className={
                                                                        'btn btn-block btn-upload create-partner-button'
                                                                    }
                                                                    type={
                                                                        'button'
                                                                    }
                                                                    onClick={() =>
                                                                        document
                                                                            .getElementById(
                                                                                'form_submit_botton',
                                                                            )
                                                                            .click()
                                                                    }
                                                                >
                                                                    {isPartnerCreateRequested ? (
                                                                        <img
                                                                            src={
                                                                                LoaderGif
                                                                            }
                                                                            width={
                                                                                '25px'
                                                                            }
                                                                            height={
                                                                                '25px'
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        'Create Account'
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Modal code ends here */}
                                        </Modal>
                                    </div>
                                ) : null}
                            </div>
                            <div className="row">
                                <div className="col-12 mt-5 partner-pickup">
                                    <PickupCount
                                        countText={countText}
                                        count={count}
                                        total={total}
                                        loading={loading}
                                    />
                                </div>
                                <div className="col-12">
                                    <ProgressBar
                                        progress={(count / total) * 100}
                                    />
                                </div>
                            </div>
                        </div>
                        {partners
                            ? partners.map((element) => (
                                  <>
                                      <div className="row mb-4">
                                          <div className="col">
                                              <Accordion>
                                                  <Card className="d-flex accordion-card">
                                                      <Accordion.Collapse
                                                          eventKey={3}
                                                          className="segmentCardBody"
                                                      >
                                                          <Card.Body>
                                                              <Row>
                                                                  <Col>
                                                                      {deleteError &&
                                                                      deleteChildId ===
                                                                          element.id ? (
                                                                          <div className="row ml-1">
                                                                              {
                                                                                  deleteError
                                                                              }
                                                                          </div>
                                                                      ) : null}
                                                                      {childPartnerInProgress &&
                                                                      childPartnerInProgressId ===
                                                                          element.id ? (
                                                                          <div className="row justify-content-center">
                                                                              <img
                                                                                  src={
                                                                                      LoaderGif
                                                                                  }
                                                                              />
                                                                          </div>
                                                                      ) : (
                                                                          <UserList
                                                                              users={
                                                                                  element.users
                                                                              }
                                                                              onRemoveUser={(
                                                                                  id,
                                                                              ) =>
                                                                                  onRemoveChildUser(
                                                                                      element.id,
                                                                                      id,
                                                                                  )
                                                                              }
                                                                              onCancelInvite={(
                                                                                  email,
                                                                              ) =>
                                                                                  onCancelInvite(
                                                                                      email,
                                                                                      element.id,
                                                                                  )
                                                                              }
                                                                              showDeleteButton={
                                                                                  showDeleteButton
                                                                              }
                                                                          />
                                                                      )}
                                                                      <div className="add-user">
                                                                          {showAddButton
                                                                              ? addToList(
                                                                                    element.id,
                                                                                    element.licenseCount,
                                                                                )
                                                                              : null}
                                                                      </div>
                                                                  </Col>
                                                              </Row>
                                                              {(emailError &&
                                                                  emailChildId ===
                                                                      element.id) ||
                                                              (emailFormatError &&
                                                                  childEmailFormatErrorId) ? (
                                                                  <div className="row ml-1">
                                                                      {emailError
                                                                          ? emailError
                                                                          : emailFormatError}
                                                                  </div>
                                                              ) : null}
                                                          </Card.Body>
                                                      </Accordion.Collapse>
                                                      <Accordion.Toggle
                                                          as={Card.Header}
                                                          eventKey={3}
                                                          className="segmentCardHeader"
                                                      >
                                                          <div className="row m-0">
                                                              <div className="col-4 userInfo d-flex align-items-center">
                                                                  <Avator
                                                                      variant={
                                                                          'Medium'
                                                                      }
                                                                      source={`${element.profilePicture}`}
                                                                  />
                                                                  <div className="userName">
                                                                      <h4 className="title">
                                                                          {
                                                                              element.name
                                                                          }
                                                                      </h4>
                                                                  </div>
                                                              </div>
                                                              <div className="col">
                                                                  <div className="row">
                                                                      <div className="col-11">
                                                                          <div className="stats">
                                                                              <small className="title text-uppercase">
                                                                                  Total
                                                                                  Pieces
                                                                              </small>
                                                                              <div className="stat h2 text-primary">
                                                                                  {
                                                                                      element.partnerLitterCount
                                                                                  }
                                                                              </div>
                                                                          </div>
                                                                      </div>
                                                                      <div className="col-1 align-self-center text-right">
                                                                          <svg
                                                                              className="ico-arrowCollapse"
                                                                              xmlns="http://www.w3.org/2000/svg"
                                                                              width="16"
                                                                              height="16"
                                                                              viewBox="0 0 16 16"
                                                                          >
                                                                              <path
                                                                                  fill="#000"
                                                                                  fillRule="nonzero"
                                                                                  d="M8.876 8.047l-3.3-3.3a.667.667 0 0 1 .943-.942l3.771 3.771c.26.26.26.682 0 .943L6.519 12.29a.667.667 0 0 1-.943-.943l3.3-3.3z"
                                                                              />
                                                                          </svg>
                                                                      </div>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </Accordion.Toggle>
                                                  </Card>
                                              </Accordion>
                                          </div>
                                      </div>
                                  </>
                              ))
                            : null}
                    </div>
                );
            default:
                return <></>;
        }
    }

    return <>{getContent(cardType)}</>;
}

AdminContentCard.propTypes = {
    // To display the heading in the card
    heading: PropTypes.string,

    cardType: PropTypes.string,

    // To display the sub heading in the card
    subHeading: PropTypes.string,

    // Boolean to control if the drop down should be displayed or not
    showDropDown: PropTypes.bool,

    // The content to be rendered in the body of the card
    content: PropTypes.any,

    // Label for the drop down
    dropDownLabel: PropTypes.string,

    // obj to generate the menu items of the drop down
    dropDownData: PropTypes.array,

    // To invoke a function on the press or click of a menu item of the drop down
    dropDownOnClick: PropTypes.func,

    // To select between the variants of drop down for e.g checkbox variant or list variant
    dropDownVariant: PropTypes.string,

    inputTitle: PropTypes.string,

    //an array of Users
    users: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            profilePicture: PropTypes.string,
        }),
    ),

    partners: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            profilePicture: PropTypes.string,
            totalCount: PropTypes.string,
        }),
    ),

    onAddUser: PropTypes.func,

    onAddChildUser: PropTypes.func,

    onRemoveUser: PropTypes.func,

    onCancelInvite: PropTypes.func,

    onRemoveChildUser: PropTypes.func,

    onPartnerCreate: PropTypes.func,

    countText: PropTypes.string,
    loading: PropTypes.bool,
    count: PropTypes.number,

    total: PropTypes.number,

    showPartnerButton: PropTypes.bool,

    showDeleteButton: PropTypes.bool,

    showAddButton: PropTypes.bool,

    userId: PropTypes.number,

    emailError: PropTypes.string,

    emailChildId: PropTypes.string,

    deleteError: PropTypes.string,

    deleteChildId: PropTypes.string,

    showLoading: PropTypes.bool,

    childRequested: PropTypes.bool,

    childRequestedId: PropTypes.number,

    onClearErrors: PropTypes.func,

    createPartnerError: PropTypes.string,

    isPartnerCreateRequested: PropTypes.bool,

    childTotal: PropTypes.number,

    childPartnerInProgress: PropTypes.bool,

    childPartnerInProgressId: PropTypes.number,
};

AdminContentCard.defaultProps = {
    heading: null,
    subHeading: null,
    showDropDown: false,
    content: null,
    inputTitle: null,
    countText: '',
    loading: false,
    // error: null,
    count: null,
    total: null,
    showPartnerButton: false,
    showDeleteButton: false,
    showAddButton: false,
    userId: null,
    emailError: null,
    emailChildId: null,
    deleteError: null,
    deleteChildId: null,
    showLoading: false,
    childRequested: false,
    childRequestedId: null,
    createPartnerError: null,
    isPartnerCreateRequested: false,
    childTotal: null,
};

export default AdminContentCard;
